export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_03.37d53d70.png";